/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-09-13 14:53:45
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-22 15:15:36
 */
import { Col, Row, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import styles from './TcmCases.module.css'

interface HistoryTitleProps {
  t: any
  CollapseActivekey: string
}

export const HistoryTitle = ({ t, CollapseActivekey }: HistoryTitleProps) => {
  return <Row justify='space-between' style={{
    width: '100%', overflow: 'hidden',
    fontWeight: CollapseActivekey == t.id ? 600 : 400
  }}>
    <Col className={styles.historyTitle} span={8}>
      <Tooltip title={t.disease} placement="topLeft">
        <span >{t.disease?.split('/')?.[0]}</span>
      </Tooltip>
    </Col>
    <Col className={styles.historyTitles} span={16}>
      <Tooltip title={t.treatmentDoctorName + ' ' + t.treatmentDepartmentName + ' ' + moment(t.createTime).format('YY/MM/DD')} placement="topRight">
        <span>
          {t.treatmentDoctorName}&ensp;{t.treatmentDepartmentName}&ensp;{moment(t.createTime).format('YY/MM/DD')}
        </span>
      </Tooltip>
    </Col>
  </Row>
}